export var PenumbraRequestFailure;
(function (PenumbraRequestFailure) {
    PenumbraRequestFailure["Denied"] = "Denied";
    PenumbraRequestFailure["NeedsLogin"] = "NeedsLogin";
})(PenumbraRequestFailure || (PenumbraRequestFailure = {}));
export class PenumbraProviderNotAvailableError extends Error {
    constructor(providerOrigin, opts) {
        super(`Penumbra provider ${providerOrigin} is not available`, opts);
        this.name = 'PenumbraProviderNotAvailableError';
    }
}
export class PenumbraProviderNotConnectedError extends Error {
    constructor(providerOrigin, opts) {
        super(`Penumbra provider ${providerOrigin} is not connected`, opts);
        this.name = 'PenumbraProviderNotConnectedError';
    }
}
export class PenumbraProviderRequestError extends Error {
    constructor(providerOrigin, opts) {
        super(`Penumbra provider ${providerOrigin} did not approve request`, opts);
        this.name = 'PenumbraProviderRequestError';
    }
}
export class PenumbraNotInstalledError extends Error {
    constructor(message = "Penumbra global `window[Symbol.for('penumbra')]` is not present.", opts) {
        super(message, opts);
        this.name = 'PenumbraNotInstalledError';
    }
}
